var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card my-5"},[_c('div',{staticClass:"card-header bg-info"},[_vm._v(_vm._s(_vm.greeting.subject))]),_vm._v(" "),_c('div',{staticClass:"card-body"},_vm._l((_vm.greeting.sentences),function(sentence,index){return _c('div',{key:index,staticClass:"blockquote"},[_c('Sentence',{attrs:{"sentence":sentence}}),_vm._v(" "),_c('h6',{staticClass:"card-subtitle mb-2 text-muted"},[_vm._v(_vm._s(sentence.mean))])],1)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f9679428","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/greetings/Row.vue
// module id = 71
// module chunks = 0